var React = require('react');

function BackgroundV (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_309","data-name":"Group 309","opacity":"0.08"},React.createElement("path",{"id":"Path_1","data-name":"Path 1","d":"M459.775,906.026,151.118,84H391L593.034,683.228,795.071,84h237.572L727.363,906.461Z","transform":"translate(-151.118 -84)","fill":"#fff"})));
}

BackgroundV.defaultProps = {"viewBox":"0 0 881.525 822.461"};

module.exports = BackgroundV;

BackgroundV.default = BackgroundV;
